qw-card {
  --qw-card-background: transparent;
  
  display: flex;
  flex-direction: column;
  background-color: var(--qw-card-background);
}
